<template>
  <div class="queryContent">
    <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem>中美加征 </BreadcrumbItem>
      </Breadcrumb>
    </div>

    <div class="query-header scroll-border-dom">
      <div class="query-header-wrap">
        <div class="inputs-wrap">
          <Tabs v-model="currentQueryType">
            <TabPane label="进口税率" name="import"></TabPane>
            <!-- <TabPane label="出口查询" name="export" icon="logo-windows"></TabPane> -->
          </Tabs>

          <div class="query-inputs">
            <div class="inputs clearfix" @keyup="escEvent">
              <template v-if="currentQueryType == 'import'">
                <Export
                  class="ex"
                  ref="ex"
                  :width="'200%'"
                  :currentState="currentState"
                  styleName="n"
                  @handleClick="handleClick"
                  @closeDropdown="closeDropdown"
                ></Export>
                <Import
                  class="im"
                  ref="im"
                  :width="'200%'"
                  :currentState="currentState"
                  styleName="n"
                  @handleClick="handleClick"
                  @closeDropdown="closeDropdown"
                ></Import>
              </template>
              <template v-else>
                <Export
                  class="ex"
                  ref="ex"
                  :width="'200%'"
                  :currentState="currentState"
                  styleName="n"
                  @handleClick="handleClick"
                  @closeDropdown="closeDropdown"
                ></Export>
                <Import
                  class="im"
                  ref="im"
                  :width="'200%'"
                  :currentState="currentState"
                  styleName="n"
                  @handleClick="handleClick"
                  @closeDropdown="closeDropdown"
                ></Import>
              </template>
              <Product
                placeholderText="商品编码/商品名称"
                class="pr"
                ref="pr"
                :currentState="currentState"
                styleName="n"
                :countrycode="countrycode"
                @handleClick="handleClick"
                @closeDropdown="closeDropdown"
              ></Product>
            </div>
            <div class="btn-wrap clearfix">
              <Button
                type="primary"
                class="btn search"
                @click.prevent="searchHandle"
              >
                <span v-if="!isShowLoader"><span>搜索</span></span>
                <span v-else>{{ $t("common.loading") }}</span>
              </Button>
              <Button
                class="btn reset"
                type="primary"
                @click.prevent="resetHandle"
                :disabled="isShowLoader"
                ><span>{{ $t("btn.reset") }}</span></Button
              >
            </div>
            <!-- <Watermark></Watermark> -->
          </div>
        </div>
      </div>
    </div>
    <div class="results">
      <div class="results-wrap">
        <div class="results-content">
          <RateContentZH
            @searchAnti2="searchAnti2"
            :best="best"
            :fandata="fandata"
            :fantotalPage="fantotalPage"
            :fanpage="fanpage"
            :ranks="ranks"
            :dataSet="ftas"
            :hsData="hsData"
            :levyData="levyData"
            :currentQueryType="currentQueryType"
            :exporterData="exporterData"
            :importerData="importerData"
            :exporterID="exporter"
            :importerID="importer"
            :hscode="hscode"
          />
        </div>
      </div>
    </div>
    <Loader :loadType="1" v-show="isShowLoader" class="black"></Loader>
    <!-- <Watermark></Watermark> -->
  </div>
</template>

<script>
import Vue from "vue";
import Export from "../common/Export";
import Import from "../common/Import";
import Product from "../common/Product";
import RateContentZH from "./zh-CN/RateLevy";
import Loader from "../layout/Loader";
import Velocity from "velocity-animate";
import Watermark from "../common/Watermark.vue";
import { createNamespacedHelpers } from "vuex";
const {
  mapState: mapSearchState,
  mapMutations: mapSearchMutations
} = createNamespacedHelpers("search");
const {
  mapState: mapDataState,
  mapGetters: mapDataGetters
} = createNamespacedHelpers("data");

export default {
  name: "Rate",
  props: ["exporter", "importer", "hscode"],
  components: { Import, Export, Product, RateContentZH, Loader, Watermark },
  data() {
    return {
      currentQueryType: "import",
      $isIE: Vue._customVars.isIE,
      searchItem: {},
      fandata: [],

      fantotalPage: 0,
      fanpage: 1,
      isShowLoader: false,
      importerData: {},
      exporterData: {},
      hsData: {},
      levyData: {},
      ftas: [],
      ranks: [],
      best: {},
      t: "",
      countrycode: 27,
      searchDoing: false,
      isShowSearchMsg: true,
      changeTab: ""
    };
  },
  watch: {
    productReady(newVal, oldVal) {
      if (newVal) {
        setTimeout(() => {
          this.initInputValue();
        }, 200);
      }
    },
    exporter(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initInputValue();
        this.requestData();
      }
    },
    importer(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initInputValue();
        this.requestData();
      }
    },
    hscode(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initInputValue();
        this.requestData();
      }
    },
    $route() {
      this.t = this.$route.query._t;
    },
    currentQueryType() {
      setTimeout(() => {
        this.valueSync();
      }, 50);
    },
    t(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$refs.ex.setDefaultValue({
          id: this.$route.params.exporter,
          text: this.$route.query.text
        });
        this.initInputValue();
        this.requestData();
      }
    }
  },
  computed: {
    currentState: {
      get() {
        return this.getActiveName();
      },
      set(v) {
        this.updateState(v);
      }
    },
    ...mapSearchState({
      historyExportItem: state => state.history.exporter,
      historyImportItem: state => state.history.importer,
      historyProductItem: state => state.history.products
    }),
    apiPrice() {
      if (this._.isEmpty(this.apiValue)) {
        return null;
      } else {
        return this.getApiValue();
      }
    },
    ...mapDataState(["productReady"]),
    ...mapDataState({
      apiValue: state => state.apiValue
    })
  },
  created() {
    this.currentState = "rate";
    this.requestData();
  },
  mounted() {
    this.onTabSwitch();
    this.$nextTick(() => {
      this.currentState = "rate";
      if (!this._.isEmpty(this.getTopProduct()())) {
        this.initInputValue();
      }
      if (this.$route.params.hscode != 1) {
        this.$refs.pr.setDefaultValue({ id: this.$route.params.hscode });
      }
      if (this.$route.params.exporter != 1) {
        this.$refs.ex.setDefaultValue({
          id: this.$route.params.exporter,
          text: this.$route.query.text
        });
      }

      this.$root.$on("QuickShowEvent", () => {
        this.currentState = "rate";
        try {
          this.closeAllDropdown(!this.$data.$isIE);
        } catch (e) {}
      });
      let queryHeaderDom = document.querySelector(".query-header");
      let resultDom = document.querySelector(".results");
      let footer = document.querySelector("footer");
      resultDom.style.minHeight =
        this._h.getWinHeight() -
        this._h.getOuterElSize(footer).height -
        Math.abs(
          this._h.getScrollTop() -
            Math.abs(this._h.getOffset(queryHeaderDom).bottom)
        ) +
        "px";
    });
  },
  methods: {
    valueSync() {
      this.$refs.ex.$el.style.display = "block";
      this.$refs.im.$el.style.display = "block";
      this.$refs.ex.$el.style.width = "1%";
      this.$refs.ex.$el.style.opacity = 0;
      this.$refs.im.$el.style.width = "1%";
      this.$refs.im.$el.style.opacity = 0;
      this.$refs.pr.$el.style.width = "1%";
      this.$refs.pr.$el.style.opacity = 0;
      Velocity(
        this.$refs.ex.$el,
        { width: "29%", opacity: 1 },
        { duration: 250 }
      );
      Velocity(
        this.$refs.im.$el,
        { width: "29%", opacity: 1 },
        { duration: 250, delay: 50 }
      );
      Velocity(
        this.$refs.pr.$el,
        { width: "42%", opacity: 1 },
        { duration: 250, delay: 50 }
      );
    },
    onTabSwitch() {
      if (this.changeTab !== this.currentQueryType) {
        let chana = { id: 27, text: "中国" };
        let America = { id: 210, text: "美国" };
        if (this.currentQueryType === "import") {
          this.countrycode = 27;
          // console.log(222);
          // this.$refs.ex.isRead = false;
          // if (this.$refs.im.value.id != chana.id) {
          //   this.$refs.ex.setDefaultValue(this.$refs.im.value);
          // }
          //固定查美国
          this.$refs.ex.isRead = true;
          this.$refs.ex.setDefaultValue(America);
          this.$refs.im.isRead = true;
          this.$refs.im.setDefaultValue(chana);
        } else if (this.currentQueryType === "export") {
          this.$refs.im.isRead = false;
          this.countrycode = this.$refs.ex.value.id;
          if (this.$refs.ex.value.id != chana.id) {
            this.$refs.im.setDefaultValue(this.$refs.ex.value);
          }
          this.$refs.ex.isRead = true;
          this.$refs.ex.setDefaultValue(chana);
        }

        this.best = {};
        this.ranks = [];
        this.hsData = {};
        this.levyData = {};
        this.ftas = [];
        this.importerData = {};
        this.exporterData = {};
      }
      this.changeTab = this.currentQueryType;
    },
    delayRequestData() {
      setTimeout(() => {
        this.requestData();
      }, 500);
    },
    async searchAnti2(page) {
      let response3 = await this.$api.query.searchAnti2(
        this.exporter,
        this.hscode,
        page
      );
      if (response3.data.code === 200) {
        this.fandata = response3.data.data.result;

        this.fantotalPage = response3.data.data.count || 0;
      } else {
        this.$Message.warning({
          content: this.$t("common.codeError"),
          closable: true
        });
      }
    },
    getLevy() {
      this.$api.query.levy(this.importer, this.exporter, this.hscode, 1, {
        success: response => {
          if (response.data.code === 200) {
            if (!this._.isEmpty(response.data.data.levy)) {
              this.levyData = response.data.data.levy;
              this.levyData.startTime = this.levyData.startTime
                ? this.levyData.startTime.slice(0, 10)
                : "";
              this.levyData.endTime = this.levyData.endTime
                ? this.levyData.endTime.slice(0, 10)
                : "";
            } else {
              this.levyData = {};
              this.$Message.warning({
                content: this.$t("query.message.search_none"),
                closable: true
              });
            }
          } else if (response.data.code === 404) {
            this.$Message.warning({
              content: this.$t("query.message.search_none"),
              closable: true
            });
            // } else if (response.data.code === 505) {
            //   this.GMessage('warning', this.$t('query.message.search_frequent'), '去充值', { name: 'Recharge' })
          } else if (response.data.code === 401) {
            // this.GMessage('warning', this.$t('query.message.search_perm_limit2'), '登录', { path: '/my' })
            this.$Message.error({
              content: this.$t("query.message.search_perm_limit2"),
              closable: false
            });
            // } else if (response.data.code === 506) {
            //   this.GMessage('warning', this.$t('query.message.search_perm_limit'), '登录', { path: '/my' })
          } else {
            this.$Message.warning({
              content: response.data.message,
              closable: true
            });
          }
        },
        error: errorMsg => {
          this.$Message.error({
            content: this.$t("common.tryAgain"),
            closable: true
          });
          this.$Loading.error();
        }
      });
    },
    requestData() {
      if (this.isShowLoader) {
        // this.delayRequestData()
        return;
      }
      if (this.importer == 1 && this.hscode == 1 && this.exporter == 1) return;

      this.$Loading.start();
      this._h.scrollTop();
      this.isShowLoader = true;

      this.$api.query.tax(this.importer, this.exporter, this.hscode, {
        success: response => {
          this.$Loading.finish();
          this.$refs.pr && this.$refs.pr.closeDowndown(false);
          this.getLevy();
          if (response.data.code === 200) {
            if (!this._.isEmpty(response.data.data)) {
              this.importerData = response.data.data.importer;
              this.exporterData = response.data.data.exporter;
              this.hsData = response.data.data.hs;
              this.ftas = response.data.data.ftas;
              let ranks = response.data.data.ranks;
              let arr = [];

              for (let index = 0; index < ranks.length; index++) {
                if (!arr.find(item => item.name == ranks[index].name)) {
                  arr.push({
                    name: ranks[index].name,
                    children: [{ ...ranks[index] }]
                  });
                } else {
                  arr.map(item => {
                    if (item.name == ranks[index].name) {
                      item.children.push({ ...ranks[index] });
                    }
                  });
                }
              }
              this.ranks = arr;
              this.best = response.data.data.best;
            } else {
              this.$Message.warning({
                content: this.$t("query.message.search_none"),
                closable: true
              });
            }
          } else if (response.data.code === 404) {
            this.$Message.warning({
              content: this.$t("query.message.search_none"),
              closable: true
            });
            // } else if (response.data.code === 505) {
            //   this.GMessage('warning', this.$t('query.message.search_frequent'), '去充值', { name: 'Recharge' })
          } else if (response.data.code === 401) {
            // this.GMessage('warning', this.$t('query.message.search_perm_limit2'), '登录', { path: '/my' })
            this.$Message.error({
              content: this.$t("query.message.search_perm_limit2"),
              closable: false
            });
            // } else if (response.data.code === 506) {
            //   this.GMessage('warning', this.$t('query.message.search_perm_limit'), '登录', { path: '/my' })
          } else {
            this.$Message.warning({
              content: response.data.message,
              closable: true
            });
          }
          this.isShowLoader = false;
        },
        error: errorMsg => {
          this.isShowLoader = false;
          this.$Message.error({
            content: this.$t("common.tryAgain"),
            closable: true
          });
          this.$Loading.error();
        }
      });
      this.searchAnti2(1);
    },
    initInputValue() {
      let exporterItem = this.getExporterById()(this.exporter);
      let impoterItem = this.getImporterById()(this.importer);
      let productItem = this.getProductByCode()(this.hscode);
      if (
        !this._.isEmpty(exporterItem) &&
        !this._.isEmpty(impoterItem) &&
        !this._.isEmpty(productItem)
      ) {
        this.$refs.ex.setDefaultValue({
          id: exporterItem.id,
          text: exporterItem.name
        });
        this.$refs.im.setDefaultValue({
          id: impoterItem.id,
          text: impoterItem.name
        });
        this.$refs.pr.setDefaultValue({
          id: productItem.code,
          text: productItem.name
        });
        this.searchItem = {
          exporter: exporterItem,
          impoter: impoterItem,
          product: productItem
        };
      } else if (
        !this._.isEmpty(this.historyExportItem) &&
        !this._.isEmpty(this.historyImportItem) &&
        !this._.isEmpty(this.historyProductItem)
      ) {
        // this.$refs.ex.setDefaultValue(this.historyExportItem[0])
        // this.$refs.im.setDefaultValue(this.historyImportItem[0])
        // this.$refs.pr.setDefaultValue(this.historyProductItem[0])
        // this.searchItem = {exporter: this.historyExportItem[0], impoter: this.historyImportItem[0], product: this.historyProductItem[0]}
      }
    },
    resetHandle() {
      this.$refs.ex && this.$refs.ex.resetContent(false);
      this.$refs.im && this.$refs.im.resetContent(false);
      this.$refs.pr && this.$refs.pr.resetContent(false);
      this.best = {};
      this.ranks = [];
      this.hsData = {};
      this.levyData = {};
      this.ftas = [];
      this.importerData = {};
      this.exporterData = {};
    },
    searchByOther(hasDropdown = false) {
      this.searchDoing = false;
      if (this.$refs.ex.text && !this.$refs.ex.value.id) {
        if (!hasDropdown && this.isShowSearchMsg) {
          this.$Message.warning({
            content: this.$t("query.message.export_error"),
            closable: true
          });
        }
        this.isShowSearchMsg = true;
        return;
      }
      if (this.$refs.im.text && !this.$refs.im.value.id) {
        if (!hasDropdown && this.isShowSearchMsg) {
          this.$Message.warning({
            content: this.$t("query.message.import_error"),
            closable: true
          });
        }
        this.isShowSearchMsg = true;
        return;
      }
      if (!this.$refs.pr.text) {
        if (!hasDropdown && this.isShowSearchMsg) {
          this.$Message.warning({
            content: this.$t("query.message.product_error"),
            closable: true
          });
        }
        this.isShowSearchMsg = true;
        return;
      }
      this.jfNotice2();
    },
    searchHandle() {
      if (this.searchDoing) return;
      this.searchDoing = true;
      if (!this.$refs.ex || !this.$refs.im || !this.$refs.pr) return;
      if (
        this.$refs.ex.isShowDropDown ||
        this.$refs.im.isShowDropDown ||
        this.$refs.pr.isShowDropDown
      ) {
        setTimeout(() => {
          this.searchByOther(true);
        }, 150);
      } else {
        this.searchByOther();
      }
    },
    jfNotice2() {
      if (this.$i18n.locale === "zh-CN") {
        this.GJFNotice(status => {
          if (status) {
            let jf = this.getApiValue()(1);
            if (jf && jf.integral && jf.integral > 0) {
              this.GConfirm(
                `本次查询将消耗${jf.integral}积点，当天重复查询不再扣除积点。`,
                status => {
                  if (status) {
                    this.searchHandleAfter();
                  }
                }
              );
            } else {
              this.searchHandleAfter();
            }
          } else {
            this.searchHandleAfter();
          }
        });
      } else {
        this.searchHandleAfter();
      }
    },
    searchHandleAfter() {
      if (!this.$refs.ex || !this.$refs.im || !this.$refs.pr) return;

      this.$refs.ex && this.$refs.ex.setValueFromDefaultPlaceholder();
      this.$refs.im && this.$refs.im.setValueFromDefaultPlaceholder();
      if (!this.$refs.ex.text) {
        this.$Message.warning({
          content: this.$t("query.message.export_empty"),
          closable: true
        });
        return;
      }
      if (!this.$refs.ex.value.id) {
        this.$Message.warning({
          content: this.$t("query.message.export_error"),
          closable: true
        });
        return;
      }
      if (!this.$refs.im.text) {
        this.$Message.warning({
          content: this.$t("query.message.import_empty"),
          closable: true
        });
        return;
      }
      if (!this.$refs.im.value.id) {
        this.$Message.warning({
          content: this.$t("query.message.import_error"),
          closable: true
        });
        return;
      }
      if (this.$refs.ex.value.id === this.$refs.im.value.id) {
        this.$Message.warning({
          content: this.$t("query.message.notEqu"),
          closable: true
        });
        return;
      }
      this.$refs.pr && this.$refs.pr.setValueFromDefaultPlaceholder();
      if (!this.$refs.pr.text) {
        this.$Message.warning({
          content: this.$t("query.message.product_empty"),
          closable: true
        });
        return;
      }
      if (!this.$refs.pr.text) {
        this.$Message.warning({
          content: this.$t("query.message.product_error"),
          closable: true
        });
        return;
      }
      this.updateHistory({
        exporter: this.$refs.ex.value,
        importer: this.$refs.im.value,
        products: this.$refs.pr.value
      });
      switch (this.currentState) {
        case "rate":
          this.$router.push({
            name: "queryRateLevy",
            params: {
              exporter: this.$refs.ex.value.id,
              importer: this.$refs.im.value.id,
              hscode: this.$refs.pr.text
            },
            query: {
              _t: new Date().getTime(),
              text: this.$refs.ex.value.text
            }
          });
          break;
      }
    },
    handleClick(event, componentName) {
      switch (componentName) {
        case "exporter":
          this.$refs.im.closeDowndown(false);
          this.$refs.pr.closeDowndown(false);
          break;
        case "importer":
          this.$refs.ex.closeDowndown(false);
          this.$refs.pr.closeDowndown(false);
          break;
        case "product":
          this.$refs.ex.closeDowndown(false);
          this.$refs.im.closeDowndown(false);
          break;
      }
    },
    enterEvent(event, componentName) {
      switch (componentName) {
        case "ex":
          if (this.$refs.ex.text) {
            this.setAutomatic(componentName);
          }
          break;
        case "im":
          if (this.$refs.im.text) {
            this.setAutomatic(componentName);
          }
          break;
        case "pr":
          if (this.$refs.pr.text) {
            this.setAutomatic(componentName);
          }
          break;
      }
      setTimeout(() => {
        // if (this.$refs.ex.value.id && this.$refs.im.value.id && this.$refs.pr.value.id) {
        this.isShowSearchMsg = false;
        this.searchHandle();
        // }
      }, 300);
    },
    escEvent(event) {
      if (event && event.keyCode === 27) {
        this.closeAllDropdown();
      }
    },
    tabEvent(event, componentName) {
      this.setAutomatic(componentName);
    },
    closeDropdown(event, componentName) {
      this.setAutomatic(componentName, false);
    },
    closeAllDropdown(isBlur = true) {
      this.$refs.ex.closeDowndown(isBlur);
      this.$refs.im.closeDowndown(isBlur);
      this.$refs.pr.closeDowndown(isBlur);
    },
    setAutomatic(componentName, isNextDropDown = true) {
      switch (componentName) {
        case "ex":
          this.$refs.ex.closeDowndown(true);
          if (isNextDropDown || this.$refs.ex.text) {
            if (!this.$refs.im.text) {
              this.$refs.im.inputClick();
            } else if (!this.$refs.pr.text) {
              this.$refs.pr.inputClick();
            }
          }
          break;
        case "im":
          this.$refs.im.closeDowndown(true);
          this.countrycode = this.$refs.im.value.id;
          if (isNextDropDown || this.$refs.im.text) {
            if (!this.$refs.pr.text) {
              this.$refs.pr.inputClick();
            }
          }
          break;
        case "pr":
          this.$refs.pr.closeDowndown(true);
          break;
      }
    },
    ...mapSearchState({
      getActiveName: state => state.activeName
    }),
    ...mapSearchMutations(["updateState", "updateHistory"]),
    ...mapDataGetters([
      "getApiValue",
      "getExporterById",
      "getImporterById",
      "getProductByCode",
      "getTopProduct"
    ])
  }
};
</script>
<style scoped>
.query-tp {
  background-color: #fff;
  margin-bottom: 30px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
>>> .ivu-tabs-nav .ivu-tabs-tab-active {
  /* color: #2d8cf0; */
  color: #333;
  font-size: 16px;
  padding: 8px 30px;
  border-bottom: 4px solid #2d8cf0;
  font-weight: bold;
}
.query-stitle {
  color: #323232;
  font-weight: bold;
  font-size: 15px;
  padding: 14px 18px 4px;
}
.ex,
.im {
  width: 29%;
  float: left;
  border-right: 0 none !important;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.pr {
  width: 42%;
  float: left;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
.im {
  border-radius: 0;
}
.results {
  position: relative;
}
.queryContent {
  background-color: #fff;
}
.inputs-wrap {
  background-color: #fff;
  padding: 12px 0 20px;
  border-radius: 3px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}

.queryContent .query-header-wrap,
.results-wrap {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 20px;
}
.queryContent .query-header-wrap {
  padding-top: 20px;
  padding-bottom: 10px;
}
.query-slogon {
  margin: 0 0 10px;
  padding-left: 1px;
  font-size: 14px;
  color: #666;
  font-weight: bold;
}
.query-inputs {
  position: relative;
  padding-left: 1px;
  padding: 0 20px;
  padding-right: 310px;
}
.query-inputs .inputs {
  /* width: 65%; */
}
.query-inputs .inputs >>> .search-input-item .title {
  margin-bottom: 0;
}
.query-inputs .inputs >>> .search-input-item {
  border-width: 0.5px;
}
.btn-wrap {
  position: absolute;
  right: 20px;
  margin-left: 8px;
  bottom: 0;
  padding: 3px 0;
  height: 40px;
}
.btn {
  width: 130px;
  border: 1px solid #1f8afd;
  border-radius: 3px;
  height: 100%;
  float: left;
  /*font-size: 12px;*/
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  position: relative;
}
.btn span {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.btn.search {
  border-color: #8892f3;
  background-color: #8892f3;
  color: #fff;
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  letter-spacing: 2px;
  /* transition: all .3s; */
}
/* .btn.search:hover{
    border-color: #000;
  } */
.btn.ivu-btn-loading {
  cursor: default;
}
.btn.ivu-btn-loading span {
  position: static;
  transform: none;
}
.btn.reset {
  background-color: #fff;
  border-color: #8892f3;
  color: #8892f3;
  margin-left: 20px;
  /* transition: all .3s; */
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  letter-spacing: 2px;
}
.btn.reset[disabled] {
  color: #bbbec4;
  /*background-color: #f7f7f7;*/
  border-color: #dddee1;
  cursor: default;
}
/* .btn.reset:hover{
    color: #fff;
    border-color: #000;
  } */
.results {
  background-color: #fff;
  position: relative;
  padding: 23px 0;
}
.results-wrap {
  padding-left: 1px;
}
.shadow-divide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  box-shadow: 0 2px 4px 0 rgba(223, 223, 223, 0.5);
  z-index: 1;
  height: 5px;
  background-color: #fff;
}
.results-content {
  /* margin-top: 15px; */
  /*position: relative;*/
  /*padding-right: 235px;*/
}
</style>
<style scoped>
.caption {
  font-size: 16px;
  color: #333;
  background: url("~@/assets/images/home/guide.png") 0 center no-repeat
    transparent;
  background-size: 12px;
  padding-left: 18px;
  margin-bottom: 15px;
  position: relative;
}

.card-rate-wrap {
  margin: 0 10px 20px;
  position: relative;
  background-color: #fff;
  border: 1px solid #ececec;
  box-shadow: 3px 3px 5px 0 rgba(225, 225, 225, 0.5);
  /*height: 66px;*/
  height: 86px;
  max-width: 230px;
  background-color: #8892f3;
  border-radius: 6px;
}
.card-rate-card:nth-child(2n) .card-rate-wrap {
  background-color: #bc8cf0;
}
.card-rate-card:nth-child(3n) .card-rate-wrap {
  background-color: #ffa799;
}
.card-rate-card:nth-child(4n) .card-rate-wrap {
  background-color: #8ac3fa;
}
.card-rate-card:nth-child(5n) .card-rate-wrap {
  background-color: #46cece;
}
.card-rate-content {
  color: #fff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  right: 10px;
}
.card-rate-content .name,
.card-rate-content .name2 {
  float: left;
  font-size: 15px;
}
.card-rate-content .name,
.card-rate-content .name2 {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
.card-rate-content .value,
.card-rate-content .value2 {
  float: right;
  font-size: 15px;
  color: #fff;
  font-weight: bold;
}
.card-rate-content .value.multi,
.card-rate-content .value2.multi {
  font-size: 12px;
}
.card-rate-content .value >>> .unit,
.card-rate-content .value2 >>> .unit {
  /*font-size: 9px;*/
  font-size: 11px;
  color: #fff;
}
.card-rate-content .value2 >>> .unit {
  color: #fff;
}
.card-rate-content .value2 {
  text-align: right;
  color: #fff;
}
.card-rate-content .value2 a {
  font-size: 13px;
  color: #fff;
  font-weight: normal;
}
/* .card-rate-content .value2 a:after{
    background-color: #1F8AFD;
  } */
.recommend {
  padding: 0 0 0 45px;
  background: url("~@/assets/images/home/light.png") 18px center no-repeat
    transparent;
  background-size: 20px;
  position: relative;
  font-size: 15px;
  margin-top: 30px;
  /* cursor: pointer; */
}
.cursor {
  cursor: pointer;
}
.recommend .title {
  float: left;
  color: #333;
  /*font-weight: bold;*/
}
.recommend .from {
  float: left;
  color: #151515;
  margin: 0 5px 0 0;
}
.recommend .from >>> span {
  color: #333;
  /*font-weight: bold;*/
  padding: 0 2px;
}
.recommend .value {
  float: left;
  color: #0470e3;
  font-weight: bold;
}
.recommend .saveupto {
  /*font-size: 12px;*/
  font-size: 15px;
}
.recommend .value .unit {
  /*font-size: 9px;*/
  /*font-size: 10px;*/
  font-size: 14px;
}
.recommend .saveupto .unit {
  /*font-size: 10px;*/
  font-size: 14px;
}
.recommend .close {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 15px;
}
.part2 {
  margin-top: 30px;
  position: relative;
}
.part2 .relrate {
  padding: 18px 18px 8px;
  width: 100%;
  background: #fff;
}
.part2 .relrate .cell >>> .ivu-col {
  margin-bottom: 20px;
}
.part2 .relfta,
.part3 .news {
  height: 100%;
  width: 100%;
}
.part2 .relfta-wrap,
.part3 .news-wrap {
  background: #fff;
  padding: 18px 18px 16px;
  height: 100%;
  position: relative;
}
.part2 .relfta .cell,
.part3 .news .cell {
  overflow-x: hidden;
  padding-right: 18px;
  overflow-y: auto;
}
.part2 .relfta .cell::-webkit-scrollbar-track-piece,
.part3 .news .cell::-webkit-scrollbar-track-piece {
  background: transparent;
}
.part2 .relfta .cell::-webkit-scrollbar,
.part3 .news .cell::-webkit-scrollbar {
  width: 4px;
}
.part2 .relfta .cell::-webkit-scrollbar-thumb,
.part3 .news .cell::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border-radius: 20px;
}
.part3 {
  margin-top: 30px;
  position: relative;
}
.part3 .trycalwrap {
  width: 100%;
}
.part3 .trycalwrap section {
  padding: 18px 18px 8px;
}
.part3 .news .more {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  padding-right: 10px;
  font-size: 13px;
  cursor: pointer;
}
.part3 .news .more:hover {
  color: #0470e3;
}
/* .part3 .news .more::after{
    content: "";
    display: block;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translateY(-50%);
    background: url("~@/assets/images/home/ar1.png") right center no-repeat transparent;
    background-size: 12px;
  } */
.relbox {
  border: 1px solid #dfdfdf;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 78px;
  padding: 0 10px;
}
.relbox .title {
  color: #666;
}
.relbox .value {
  color: #666;
  font-weight: bold;
}
.table-containter {
  position: relative;
}
.table-containter .border-wrap {
  border: 1px solid #eaf7ff;
  position: absolute;
  top: 0;
  bottom: 9px;
  left: 0;
  width: 100%;
}

.table-wrap {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 3px;
}
.table-wrap::-webkit-scrollbar-track-piece {
  background: transparent;
}
.table-wrap::-webkit-scrollbar {
  height: 6px;
}
.table-wrap::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border-radius: 20px;
}
.table-wrap table {
  /* width: 1400px; */
}
table {
  width: 100%;
  background-color: #fff;
  /* box-shadow: -2px 0 4px 0 rgba(232,232,232,0.50), 0 -2px 4px 0 rgba(232,232,232,0.50), 2px 0 4px 0 rgba(232,232,232,0.50), 0 2px 4px 0 rgba(232,232,232,0.50); */
  /*font-size: 12px;*/
  font-size: 15px;
  color: #676767;
}
/* table thead{
    box-shadow: 0 2px 4px 0 rgba(232,232,232,0.60);
  } */
table thead th {
  color: #676767;
  font-weight: normal;
  text-align: center;
  padding: 9px 5px;
  /*font-size: 11px;*/
  font-size: 14px;
}
table thead th:first-child,
table tbody td:first-child {
  width: 120px;
}
table tbody tr:hover td {
  /*background-color: #ebf7ff !important;*/
  background-color: rgba(202, 234, 255, 0.4) !important;
}
table tbody tr td {
  /* border-bottom: 1px solid #ececec; */
  text-align: center;
  padding: 9px 0;
}
table tbody tr td:first-child {
  font-size: 15px;
}
table tbody tr:last-child td {
  border-bottom: 0;
}
table tbody tr:nth-child(odd) td {
  /* background-color: #F8F8F8; */
}
table tbody tr:nth-child(odd) td:first-child {
  /* background-color: #fff; */
}
.table-wrap .tcontent tr:nth-child(odd) td {
  background-color: #eaf7ff;
}
.table-wrap .tcontent tr td:nth-child(n + 2) {
  color: #989898;
}
table .falling,
.summary .falling {
  /*display: inline-block;*/
  height: 10px;
  background: url("~@/assets/images/icons/show/falling.png") 0 center no-repeat
    transparent;
  background-size: auto 10px;
  padding-left: 6px;
}

.chart-legend li.l3 i,
.cal-btn {
  border: 0.5px solid #8892f4;
  /*border-radius: 100px;*/
  border-radius: 30px;
  color: #8892f4;
  padding: 5px 0;
  text-align: center;
  width: 150px;
  margin: 16px auto 16px;
  cursor: pointer;
}
.cal-btn:hover {
  color: #83bdfc;
  border-color: #83bdfc;
}
table >>> .ivu-tooltip .ivu-tooltip-inner p {
  /*font-size: 11px;*/
  font-size: 13px;
  line-height: 20px;
}
.breadcrumbs {
  /*font-size: 12px;*/
  font-size: 14px;
  color: #333;
  /* width: 90%; */
  /* margin: 0 0 18px; */
  padding: 14px 18px;
  border-bottom: 1px solid #ccc;
}
.breadcrumbs >>> span span {
  color: #0470e3;
  font-weight: bold;
  cursor: default;
}
.boxshadow1 {
  box-shadow: 0 1px 6px rgb(0 0 0 / 20%);
}
.besttax {
  background-color: #f5d82b;
  position: absolute;
  font-size: 12px;
  padding: 0 5px;
  border-radius: 3px;
  right: 0;
  top: 0;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/query/RateLevy.vue